import React from 'react'
import { useTranslation } from 'react-i18next'
import { MessageType } from 'models/MessageType'
import { ImageModalSettings, SettingsType } from 'models/SettingsType'

import QuickReplyList from '../Reply/QuickReplyList'
import MessageLogo from '../MessageLogo'
import { keyType } from '../../../constants/string'

import '../Message.css'
import {
  ImageMessageContainer,
  TemplateImage,
  TemplateImageButton
} from './ImageMessage.style'

interface Props {
  url: string
  message: MessageType
  isFullScreenWidget?: boolean
  showLogo: boolean
  showReply: boolean
  settings: SettingsType
  postMessage: (msg: any) => any
  isPlacedInTheCenter: boolean
  isMobile: boolean
  isMaximized: boolean
  timestamp: Date
  avatarLogo: string
  isImageLoaded: boolean
  setIsImageLoaded: (prevState: boolean) => void
  setImageModalSettings: (props: ImageModalSettings) => void
  isLoadingIframeData: boolean
}

const ImageMessage: React.FC<Props> = ({
  url,
  message,
  showReply,
  showLogo,
  settings,
  postMessage,
  isPlacedInTheCenter,
  isMobile,
  isMaximized,
  avatarLogo,
  isImageLoaded,
  setIsImageLoaded,
  setImageModalSettings,
  isLoadingIframeData
}) => {
  const hasMessageFromBot = message.isFromBot && showLogo
  const { t } = useTranslation()

  function handleImageClick(e) {
    e.preventDefault()
    setImageModalSettings({
      imageModalSrc: url,
      imageAltText: message.imageAltText
    })
  }

  const keyDownHandler = (e) => {
    const key = e.key.toLowerCase()
    switch (key) {
      case keyType.ENTER:
      case keyType.SPACE:
        handleImageClick(e)
        break
    }
  }

  return (
    <>
      <ImageMessageContainer hasMessageFromBot={hasMessageFromBot}>
        {message.isFromBot && showLogo && <MessageLogo avatarLogo={avatarLogo} />}
        <TemplateImageButton
          onClick={handleImageClick}
          onKeyDown={keyDownHandler}
        >
          <TemplateImage
            src={url}
            alt={t('image_message')}
            onLoad={() => setIsImageLoaded(true)}
          />
        </TemplateImageButton>
      </ImageMessageContainer>
      {showReply && (
        <QuickReplyList
          isPlacedInTheCenter={isPlacedInTheCenter}
          message={message}
          replies={message.quickReplies || []}
          settings={settings}
          postMessage={postMessage}
          isMobile={isMobile}
          isMaximized={isMaximized}
          isImageLoaded={isImageLoaded}
          setIsImageLoaded={setIsImageLoaded}
          isLoadingIframeData={isLoadingIframeData}
        />
      )}
    </>
  )
}

export default ImageMessage
